<strong [appTestId]="'top-text'">{{ topText }}</strong>
<div class="bottom-text">{{ bottomText }}</div>
